import type { ReactNode } from "react";
import "./DialogActionsButtons.scss";

interface Properties {
  children: ReactNode;
}

export default function DialogActionsButtons(props: Properties): ReactNode {
  return <div className="dialog-actions-buttons">{props.children}</div>;
}
